/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Components_Upgrade_Plan_Modal_Features_StorageInputs */

const es_components_upgrade_plan_modal_features_storage = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_StorageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} de almacenamiento`)
};

const en_components_upgrade_plan_modal_features_storage = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_StorageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} of storage`)
};

/**
* | output |
* | --- |
* | "{value} of storage" |
*
* @param {Components_Upgrade_Plan_Modal_Features_StorageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_features_storage = /** @type {((inputs: Components_Upgrade_Plan_Modal_Features_StorageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Features_StorageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_features_storage(inputs)
	return en_components_upgrade_plan_modal_features_storage(inputs)
});
export { components_upgrade_plan_modal_features_storage as "components.upgrade_plan_modal.features.storage" }